// extracted by mini-css-extract-plugin
export default {"wrapper":"ObjectList_wrapper__cTozG","list":"ObjectList_list__CL6Sw","not_found":"ObjectList_not_found__YRuX-","text":"ObjectList_text__56aZS"};